import { useState, useEffect } from 'react';
import apiService from '../services/api';

interface State {
  state_id: number;
  state_name: string;
}

export const useStates = () => {
  const [states, setStates] = useState<State[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStates = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiService.getStates();
      
      // Handle different possible response structures
      let statesData: any[] = [];
      if (Array.isArray(response)) {
        statesData = response;
      } else if (response && (response as any).data) {
        statesData = (response as any).data;
      } else if (response && (response as any).result) {
        statesData = (response as any).result;
      } else if (response && (response as any).states) {
        statesData = (response as any).states;
      }
      
      // Filter out invalid states and ensure they have required properties
      const validStates = (statesData || []).filter((state: any) => {
        return state && 
          typeof state === 'object' && 
          state.state_id !== undefined && 
          state.state_name !== undefined;
      });
      
      setStates(validStates);
    } catch (error) {
      console.error('Error fetching states:', error);
      setError('Failed to load states. Please refresh the page.');
      setStates([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  return {
    states,
    loading,
    error,
    refetch: fetchStates
  };
};
